import React from 'react'
import { Box } from '@sainsburys-tech/fable'
import { ChevronRight } from '@sainsburys-tech/icons'
import { PriceGuaranteeIcon } from './PriceGuaranteeIcon'

export default function PriceGuaranteeMessage({ link }) {
  return (
    <div className='top-border'>
      <Box
        as='a'
        href={link}
        border={{
          radius: 'lg',
          size: 'sm'
        }}
        padding='none'
        testid='price-guarantee-component'
        className='ds-flex ds-items-stretch ds-gap-3 ds-w-full'
        style={{ borderColor: '#059669' }}
      >
        <div className='ds-bg-green-600 ds-p-2 ds-flex ds-items-center ds-justify-center ds-rounded-l-sm'>
          <PriceGuaranteeIcon width='24px' height='24px' fill='white' />
        </div>

        <div className='ds-flex-1 ds-text-left ds-min-w-0 ds-py-1 ds-leading-tight ds-text-sm'>
          <div className='ds-font-semibold ds-text-green-600'>Price guarantee*</div>
          <div className='ds-mt-0.5'>Our prices won&apos;t go lower before Christmas</div>
        </div>

        <div className='ds-flex-shrink-0 ds-mr-2 ds-flex ds-items-center'>
          <ChevronRight className='ds-w-6 ds-h-6' />
        </div>
      </Box>
    </div>
  )
}
